import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";

export default function AutoutilitaraVsAutoturismPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/autoutilitara-vs-autoturism-deductibilitate")} />
      <ArticleLayout
        eyebrow="Pe talon"
        title="Autoutilitară sau autoturism: când deduci 100% și când îți trebuie foaie de parcurs"
        lead="Pe certificat scrie autoutilitară. La control, inspectorul nu pornește de la cuvântul ăsta. Pornește de la masă, de la locuri și de la ce s-a întâmplat cu mașina."
      >
        <p>
          Mulți trec o dubă pe firmă, sau scot bancheta și reînmatriculează un autoturism
          ca <strong>N1</strong>, apoi deduc integral din prima lună. Logica sună bine:
          dacă nu mai e autoturism, limita de 50% nu se aplică. La control, logica nu
          ține.
        </p>

        <h2>Inspectorul citește alte două rubrici</h2>
        <p>
          Categoria — M1, N1, autoturism, autoutilitară — e o mențiune. Cele care schimbă
          regula sunt <strong>masa totală maximă autorizată</strong> și{" "}
          <strong>numărul de locuri, inclusiv șoferul</strong>.
        </p>
        <p>
          <strong>Art. 298</strong> din Codul fiscal limitează deducerea de TVA la 50%
          pentru vehiculele care nu trec de 3.500 kg și nu au mai mult de 9 locuri, când
          nu sunt folosite exclusiv în activitate. La impozit, aceeași limită e în{" "}
          <strong>art. 25 alin. (3) lit. l)</strong>. O dubă cu două locuri și sub 3,5
          tone stă în aceeași cutie cu un autoturism de firmă.
        </p>
        <p>
          Combustibilul, service-ul, RCA-ul și rata de leasing urmează aceeași cale.{" "}
          <strong>50%</strong>, dacă mașina e și personală. <strong>100%</strong>, dacă e
          doar de serviciu și ai cu ce o arăta. Calculul e în{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>.
        </p>

        <h2>N1 nu te scoate din regulă</h2>
        <p>
          Reînmatricularea după scoaterea banchetei schimbă rubrica de categorie. Masa
          rămâne, de obicei, sub 3.500 kg. Locurile rămân sub 9. Vehiculul e în
          continuare cel vizat de limitare. Mențiunea „autoutilitară” de pe noul
          certificat nu ține loc de excepție.
        </p>
        <p>
          Peste 3.500 kg, sau cu mai mult de 9 locuri, povestea e alta. Acolo limitarea
          chiar nu se aplică, iar cuvântul din talon se întâlnește cu pragul din lege.
          Sub ambele praguri, nu se întâlnește. Inspectorul compară cele două cifre cu
          foaia și cu bonurile, nu cu firma de pe ușă.
        </p>

        <h2>Excepția vine din activitate, nu din înmatriculare</h2>
        <p>
          Există vehicule sub 3,5 tone care deduc integral fără să demonstreze, prin
          foaie, că sunt „exclusiv economice”: curierat, pază, urgență, agenți de
          vânzări, taxi, școli de șoferi, închiriere. Proba e activitatea — obiectul
          firmei, oamenii care chiar fac treaba aia, cursele care se potrivesc.
        </p>
        <p>
          O firmă de servicii cu o dubă N1 nu devine curierat pentru că pe talon scrie
          autoutilitară. Lista excepțiilor și ce cere ANAF ca dovadă sunt în{" "}
          <Link to="/deducere-100-combustibil">articolul de deducere</Link>. Aici e doar
          ideea: talonul nu e dovada.
        </p>

        <h2>La 100%, foaia rămâne</h2>
        <p>
          Dacă dubița e sub prag și nu intră într-o excepție de activitate,{" "}
          <strong>100%</strong> se obține la fel ca la autoturism. Folosire exclusiv
          economică, și o foaie care o arată. La <strong>50%</strong>, foaia nu e piesa
          pe care o cere regula: ai recunoscut deja că vehiculul nu e doar de serviciu.
        </p>
        <p>
          Când pretinzi exclusivitatea, foaia are aceleași patru elemente: categoria,
          scopul și locul, kilometrii, norma de consum. Categoria o treci corect —
          autoutilitară, dacă așa e omologată. Nu înlocuiește masa și locurile. Cele
          patru elemente sunt în <Link to="/ghid-foaie-parcurs-anaf">ghidul ANAF</Link>.
        </p>

        <h2>Ce cade la control</h2>
        <p>
          Inspectorul nu respinge dubița din principiu. Respinge deducerea integrală
          sprijinită doar pe un cuvânt din talon.
        </p>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>De evitat</strong>
          <ul>
            <li>100% pentru că scrie autoutilitară, cu masa sub 3.500 kg.</li>
            <li>Banchetă scoasă, N1 nou, aceleași drumuri de weekend.</li>
            <li>„Curierat” sau „agent de vânzări”, fără activitatea asta.</li>
            <li>Exclusivitate fără foaie, sau cu foaie care nu se leagă de alimentări.</li>
          </ul>
        </div>
        <p>
          Dosarul de la cheltuielile auto — foi, bonuri, facturi, contracte — e în{" "}
          <Link to="/control-anaf-cheltuieli-autoturism">ghidul de control ANAF</Link>.
          Categoria din talon e o piesă. Nu e dosarul.
        </p>

        <h2>Concluzie</h2>
        <p>
          Talonul spune cum e înmatriculat vehiculul. Codul întreabă cât cântărește, câte
          locuri are și la ce a fost folosit.
        </p>
        <p>
          <strong>Dubă ușoară, sub 3,5 tone.</strong> Aceeași regulă ca autoturismul.
          50% dacă e și personală. 100% dacă e doar de serviciu și foaia o arată.
        </p>
        <p>
          <strong>Peste 3,5 tone sau peste 9 locuri.</strong> Limitarea de 50% nu se
          aplică. Acolo categoria din talon chiar se suprapune peste prag.
        </p>
        <p>
          Dacă ai scos bancheta ca să schimbi un cuvânt pe certificat, inspectorul tot
          la masă și la locuri se uită. Cuvântul nou nu închide subiectul.
        </p>
      </ArticleLayout>
    </>
  );
}
